import React from "react";
import "./landing.css"; // Create this CSS file for styling
import Navbar from "./Navbar";

const Landing = ({ imageUrl, description }) => {
  const containerStyle = {
    backgroundColor: "black",
    backgroundSize: "cover", // Cover the container without stretching
    backgroundPosition: "center", // Center the background image
    backgroundRepeat: "no-repeat", // Prevent background image from tiling
  };

  return (
    <>
      <div className="section" style={containerStyle}>
        <div className="content">
          <p>{description}</p>
        </div>
        <Navbar></Navbar>
      </div>
    </>
  );
};

export default Landing;
